import { request } from 'core/constants';
import { requestState } from 'utils/UtilityStore/actions';

export const fetch = (proposalId) => (dispatch) => {
  dispatch(requestState(true, 'proposal'));
  request
    .get(`{company}/proposal/${proposalId}`)
    .then((response) => {
      dispatch(requestState(false, 'proposal'));
      dispatch({
        type: 'FETCH_PROPOSAL',
        payload: response.data,
      });
    })
    .catch((error) => {});
};

export const clear = () => (dispatch) => {
  dispatch(requestState(null, 'proposal'));
  dispatch({
    type: 'CLEAR_PROPOSAL',
  });
};
